import { decodeHtmlCharCode } from './html'

const NBSP = '\xA0'

export const normalize = (value: string) => {
  return decodeHtmlCharCode(value)
}

// ソースエディタ表示用: 空段落マーカー(\xA0)前後の余分な空行を除去し、
// リッチエディタと同じ見た目（空段落1つ=空行1本）にする。
// "a\n\n\xA0\n\nb" → "a\n\xA0\nb"
// テーブル等が末尾に余分な改行を持つケースでも1パスで畳み切る。
export const collapseEmptyParagraphMarkers = (md: string): string => {
  const lines = md.split('\n')
  const result: string[] = []
  for (let i = 0; i < lines.length; i++) {
    if (lines[i] !== '') {
      result.push(lines[i])
      continue
    }
    let j = i
    while (j < lines.length && lines[j] === '') j++
    const followedByMarker = j < lines.length && lines[j] === NBSP
    const precededByMarker =
      result.length > 0 && result[result.length - 1] === NBSP
    if (followedByMarker || precededByMarker) {
      continue
    }
    result.push(lines[i])
  }
  return result.join('\n')
}

// リッチエディタ parse 用: 畳んだ空段落マーカーを Markdown として有効な形に展開する。
// マーカー行の前後に空行(\n\n)がないとき挿入し、marked が段落区切りとして認識できるようにする。
// "a\n\xA0\nb" → "a\n\n\xA0\n\nb"
export const expandEmptyParagraphMarkers = (md: string): string => {
  const lines = md.split('\n')
  const result: string[] = []
  for (let i = 0; i < lines.length; i++) {
    if (lines[i] === NBSP) {
      if (result.length > 0 && result[result.length - 1] !== '') {
        result.push('')
      }
      result.push(lines[i])
      if (i + 1 < lines.length && lines[i + 1] !== '') {
        result.push('')
      }
    } else {
      result.push(lines[i])
    }
  }
  return result.join('\n')
}
